import { render, staticRenderFns } from "./CourseOverview.vue?vue&type=template&id=777ad138"
import script from "./CourseOverview.vue?vue&type=script&lang=js"
export * from "./CourseOverview.vue?vue&type=script&lang=js"
import style0 from "./CourseOverview.vue?vue&type=style&index=0&id=777ad138&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports